import "./css/style.scss";
import "./hover.js";
import "./map.js";
import "./swiper.js";
import "./header.js";
import "./tablescroll.js";
import ScrollHint from 'scroll-hint';

window.ScrollHint = ScrollHint;
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fas, far, fab) 

dom.watch()